import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostService } from './host.service';
import { Cacheable } from "ts-cacheable"


@Injectable({
  providedIn: "root",
})
export class LitigeService {

  constructor(private http: HttpClient, private getAuth: HostService) {}
  
  addlitige(val: any) {
    
    return this.http.post(this.getAuth.gethttps() + "addlitige", val);

  }

  @Cacheable()
  getLitige(val: any) {
    let obj = {
      idUser: val,
    };
    return this.http.post(this.getAuth.gethttps() + "getLitige", obj);
  }

  @Cacheable()
  getAllLitige() {
    return this.http.get(this.getAuth.gethttps() + "getAllLitige");
  }

  updateStatutLitige(idlitige:number,Status:string) {
    return this.http.post(this.getAuth.gethttps() + "updateStatutLitige",{id:idlitige,status:Status});
  }
}
